module.exports = __webpack_public_path__ + "img/TLF_3000.53a7d877.svg";